module.exports = "/_next/static/files/f6e86729517c9b65e80f9ceda3d04d82.svg";